import { AnnouncementsListProps } from "./AnnouncementsList.types";
import { AnnouncementListItem } from "../../listItems/AnnouncementListItem/AnnouncementListItem";
import { useTranslation } from "react-i18next";
import { AnnouncementDTO } from "../../../../../../Api";

const AnnouncementsList = (props: AnnouncementsListProps) => {
	const { t } = useTranslation();

	return (
		<>
			{props.loading && !props.data && (
				<div className="w-full py-10 text-center">{t("generic.loading")}</div>
			)}
			{props.data?.data?.length === 0 && (
				<div className="w-full py-10 text-center">
					{t("tableText.noOffers")}
				</div>
			)}

			<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
				{props.data?.data?.map((item: AnnouncementDTO) => (
					<AnnouncementListItem
						key={item.id}
						item={item}
						currentPage={props.currentPage}
						pageSize={props.pageSize}
						searchTerm={props.searchTerm}
						location={props.location}
					/>
				))}
			</div>
		</>
	);
};

export default AnnouncementsList;
